import { getAppByIdAndVersion } from '@/redux/actions/gravityActions.js';
import { findStepApp } from '@shared/workflow/findStepApp.js';
import { updateWorkflowStep } from '@shared/workflow/updateWorkflowStep.js';

const cookUpdatedWorkflowStep = async (store, newStep, opts = {}) => {
  const apps = store?.workflow?.appsVersions;
  const appsMetadata = store?.workflow?.appsMetadata;
  const workflow = store?.workflow?.workflows?.find((n) => n?.id === newStep?.workflowId);
  const step = workflow?.steps?.find((n) => n.id === newStep?.id);
  const appId = newStep?.appId || step?.appId;
  const credential = store?.workflow?.credentials?.find((n) => n.credentialId === (newStep?.credentialId || step?.credentialId));
  const appVersion = newStep?.appVersion ?? step?.appVersion ?? '0';
  const isFunction = !!newStep?.functionId;

  let app = findStepApp({ appId, appVersion }, apps);
  if (!app) {
    app = (await getAppByIdAndVersion({ appId, appVersion }))?.[0];
  }

  if (!app && !isFunction) {
    console.error('Error updating step, cannot find app.');
    return {
      success: false,
      data: [],
      meta: {
        changes: []
      }
    };
  }

  const updatedStep = await updateWorkflowStep({
    id: newStep?.id,
    data: {
      ...newStep,
      appId,
      appVersion: newStep?.appVersion || step?.appVersion,
      workflowId: newStep?.workflowId,
      functionId: newStep?.functionId,
      updatedBy: store?.user?.jwt?.id
    },
    userId: store?.user?.jwt?.id,
    apps,
    appsMetadata,
    workflow,
    companyId: store?.user?.companyId,
    credential,
    opts
  });
  return { success: true, data: updatedStep };
};

export default cookUpdatedWorkflowStep;
